import { Box, Stack, Typography } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

import { getNewsSentimentColor } from "~/feature/chart/constants";
import type { INewsSentiment } from "~/feature/chart/types";

export const Root = styled(Stack)(({ theme }) => ({
  width: "100%",
  flexDirection: "row",
  alignItems: "center",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  padding: theme.spacing(1, 1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.text.primary, 0.03),
}));

export const Caption = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: 0.5,
  textTransform: "uppercase",
  color: theme.palette.text.secondary,
}));

export const Item = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.5),
}));

export const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$sentiment",
})<{ $sentiment: INewsSentiment }>(({ $sentiment, theme }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  flexShrink: 0,
  backgroundColor: getNewsSentimentColor(theme, $sentiment),
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  color: theme.palette.text.primary,
}));

export const Hint = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.disabled,
  marginLeft: theme.spacing(0.5),
}));
